import {ActionIcon, Avatar, Container, LoadingOverlay, Portal, Title, Tooltip} from '@mantine/core';
import { useViewportSize } from '@mantine/hooks';
import 'pro-gallery/dist/statics/main.css';
import { QRCodeCanvas } from 'qrcode.react';
import React, {useEffect, useMemo, useRef, useState} from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import logofile from "../assets/logo-alb.png";
import SelfieImage from '../assets/selfie.svg';
import AppLoadingAnimation from "../components/AppLoadingAnimation";
import BoardBar from '../components/BoardComponents/BoardBar';
import BoardGuestActions from '../components/BoardComponents/BoardGuestActions';
import BoardNotification from "../components/BoardNotification";
import Gallery from "../components/Gallery";
import ButtonCustom from '../components/Inputs/Button';
import InputGallery from '../components/Inputs/InputGallery';
import MembersPanelModal from '../components/Modals/MembersPanelModal';
import ModalPublishComponent from '../components/Modals/ModalPublishComponent';
import UploadGallery from '../components/UploadGallery';
import SelfieModal from "../components/webcam/SelfieModal";
import useBoardHook from "../utils/useBoardHook";
import useCheckAdminBoard from '../utils/useCheckAdminBoard';
import useFirebaseFunction from "../utils/useFirebaseFunction";
import getDocument from '../utils/useFirestoreDocument';
import useGetAdminDataBoard from '../utils/useGetAdminDataBoard';
import useIsInView from '../utils/useIsInView';
import useSessionPersist from "../utils/useSessionPersist";
import LoginQR from "../components/LoginQR";
import ModalQRSelfie from '../components/Modals/ModalQRSelfie';
import {isMobile} from 'react-device-detect';
import ImageIcon from '../assets/ImageIcon';
import PhotosIcon from '../assets/PhotosIcon';
import Sticky from 'react-sticky-el';
import DoubleArrowIcon from '../assets/DoubleArrowIcon';

var GeoPattern = require('geopattern');

const options = {
    galleryLayout: 0,
    isVertical: false,
    collageDensity: '1',
    imageMargin: 2,

};

// The size of the gallery container. The images will fit themselves in it

// The eventsListener will notify you anytime something has happened in the gallery.

// The scrollingElement is usually the window, if you are scrolling inside another element, suplly it here
const scrollingElement = window;


export default function BoardScreen() {
    const navigate = useNavigate();
    let { subdomain } = useParams();
    const [user, loading] = useSessionPersist();

    const [heading, setHeading] = useState(null);
    const [date, setDate] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();

    const [openModalPhotos,setOpenModalPhotos] = useState(false);
    const [universal_upload, isUploadLoading] = useFirebaseFunction("universal_upload", "europe-west1");
    const [search_face, isSearchLoading] = useFirebaseFunction("search_face", "europe-west1");

    const [showOnlyMatching, setShowOnlyMatching] = useState(false);
    const [isSelfieModalOpened, setIsSelfieModalOpened] = useState(!!searchParams.get("selfie"));
    //const [isSelfieModalOpened, setIsSelfieModalOpened] = useState(false);
    const [openModalQRSelfie,setOpenModalQRSelfie] = useState(false);
    const [selected, setSelected] = useState([]);
    const [highlightsPhotos,setHighlightsPhotos] = useState(false);
    
    const [openAdminPanel,setOpenAdminPanel] = useState(false);
    const [disableFullScreen, setDisableFullScreen] = useState(false);
    const [publishModal,setPublishModal] = useState(false);

    const [tabBoardGuest,setTabBoardGuest] = useState('selfie');


    const getDocumentBoard = useBoardHook(subdomain, true);
    const { getAdmin } = useGetAdminDataBoard(subdomain);
    const admin = useCheckAdminBoard(subdomain);
    const userData = getDocument('users')?.getDocument?.data;


    const board = getDocumentBoard?.data?.id;
    const canGuestView = admin || !!getDocumentBoard?.data?.published
    const isPublished = !!getDocumentBoard?.data?.published;
    const hasSelfie = !!userData?.search;

    const cover = getDocumentBoard?.data?.image ? `https://d2uqrxzbny1jco.cloudfront.net/fit-in/1000x1000/${getDocumentBoard?.data?.image}` : `${GeoPattern.generate(subdomain).toDataUri()}`;


    const labelTooltip = (
        <p className="tooltip-label">Adaugă o poză de fundal</p>
    )

    const fileRef = useRef(null);

    const toggleFileCover = () => {
        fileRef?.current?.click();
    }

    const onCoverChange = (e) => {
        if(e.target.files && e.target.files[0]) {
            let fileReader = new FileReader();
            fileReader.readAsDataURL(e.target.files[0]);
            fileReader.onload = (event) => {
                universal_upload({board: board, action: "board", image: event.target.result}).then(() => {
                    getDocumentBoard.refetch();
                })
            }

        }
    }




    useEffect(() => {
        if (!disableFullScreen) {
            setSelected([]);
        }
    },[disableFullScreen])

    const handleIncepeSelfie = () => {
        if(isMobile) {
            setIsSelfieModalOpened(true);
        } else {
            setOpenModalQRSelfie(true);
        }
    }

    const tabEvent = (type) => {
        if(type === 'all') {
            setShowOnlyMatching(false);
        } else {
            if (board) {
                search_face({board});
                setShowOnlyMatching(true);
            }

        }
    }

    const scrollToGallery = () => {
        var anchorGallery = document.querySelector('#pro-gallery-normal-gallery');
        var anchorSelfies = document.querySelector('#pro-gallery-default-dom-id');
        var anchorAll = document.querySelector('.picboard-gallery');

        if(anchorGallery){
            return anchorGallery.scrollIntoView();
        }

        if(anchorSelfies){
            return anchorSelfies.scrollIntoView();
        }

        if (anchorAll) {
            return anchorAll.scrollIntoView();
        }
    }

    const onFaceIdClick = () => {
       setTimeout(() => {
           if(userData?.search){
            var anchor = document.querySelector('#pro-gallery-default-dom-id');
            anchor.scrollIntoView();
           }
       }, 500)

        if (showOnlyMatching) {
            setShowOnlyMatching(false);
            return;
        }
        if (!user) {
            return;
        }
        if (!userData?.search) {
            if(isMobile){
                setIsSelfieModalOpened(true);
                return;
            } else {
                setOpenModalQRSelfie(true);
                return;
            }
        }

        if (!userData?.[`${board}_index`]) {
            return onSelfieClose(true);
        }

        setHighlightsPhotos(false);
        setShowOnlyMatching(true);

    }

    const onHighlightsPhotos = () => {
        if(!highlightsPhotos) {
            setShowOnlyMatching(false);
            setHighlightsPhotos(true);
        } else {
            setHighlightsPhotos(false);
        }
    }

    const onSelfieClose = (data) => {
        setIsSelfieModalOpened(false);
        if (data) {
            search_face({board})
                .then(() => setShowOnlyMatching(true))
        }
    }
    let faceIdLoading = loading || getDocumentBoard.isLoading || isSearchLoading;


    const { width, height } = useViewportSize();
    const [heightView,setHeightView] = useState(null);

    const container = useMemo(() => {
        return {
            width: window.innerWidth,
            height: window.innerHeight
        }
    }, [width, height]);

    useEffect(()=>{
        if(heightView === null){
            return setHeightView(height);
        }
    },[height]);


    const [desktop,setDesktop] = useState(true);
    useEffect(()=>{
        if(width > 570){
            setDesktop(true);
        } else {
            setDesktop(false);
        }
    },[width]);


    useEffect(() => {
        if (isSelfieModalOpened) {
            setSearchParams({});
        }
    }, [isSelfieModalOpened])

    useEffect(() => {
        if(!admin && board) {
            search_face({board});
            setShowOnlyMatching(true);
        } else {
            setShowOnlyMatching(false);
        }
    },[admin, board]);

    const qrCode = document.querySelector(`.qrCode${subdomain} > canvas`);
    const saveQRCode = () => {
        const pngURL = qrCode?.toDataURL('image/png',1.0).replace("image/png", "image/octet-stream");
        let downloadLink = document.createElement("a");
        downloadLink.href = pngURL;
        downloadLink.download = `${subdomain}.png`;
        downloadLink.click();
    }

    const adminAvatar = getAdmin?.avatar;
    const adminFirstName = getAdmin?.firstName;
    const adminLastName = getAdmin?.lastName;
    const adminInitials = adminFirstName?.split('')[0]+adminLastName?.split('')[0];



    const coverRef = useRef();
    const isVisibleCover = useIsInView(coverRef);

    if (!board) {
        return (<LoadingOverlay visible={true} loader={<AppLoadingAnimation/>}/>);
    }

    if (isSelfieModalOpened) {
        return (<SelfieModal opened={isSelfieModalOpened} board={board} onClose={() => setIsSelfieModalOpened(false)}/>)
    }



    return (
        <>
            <BoardGuestActions
                hasSelfie={hasSelfie}
                showOnlyMatching={showOnlyMatching}
                onFaceIdClick={onFaceIdClick}
                faceIdLoading={faceIdLoading}
            />
            <div
                style={{
                    backgroundImage: `url('${cover}')`,
                    backgroundPosition: 'center center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundColor: 'rgba(0,0,0,0.4)',
                    backgroundBlendMode: 'soft-light',
                    height: heightView ? heightView+'px' : '100vh',
                }}
                className={`relative flex justify-center items-center flex-col h-full w-full`}
            >
                <LoadingOverlay visible={isUploadLoading || getDocumentBoard.isLoading} loader={<AppLoadingAnimation/>}/>
                <input ref={fileRef} type="file" className="h-0 w-0 invisible" onChange={(e) => onCoverChange(e)} />
                <div className="absolute top-2 left-1/2 transform -translate-x-1/2 items-center text-center mt-5">
                    <ActionIcon size="xl" variant="transparent" sx={{color: "#fff", width: desktop ? "150px" : '100px'}} onClick={()=> navigate('/dashboard')}>
                        <img src={logofile} alt="logo" style={{height: 60}}/>
                    </ActionIcon>
                </div>
                {
                    getDocumentBoard?.data?.id && <div ref={coverRef} className="flex flex-col w-full px-4 justify-center items-center">
                        <InputGallery
                            board={getDocumentBoard}
                            admin={admin}
                            value={heading}
                            onChange={(e) => setHeading(e.target.value)}
                            className="headingTitle"
                        />
                        <InputGallery
                            board={getDocumentBoard}
                            admin={admin}
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                            className="headingDate"
                        />
                        {admin ?
                            <div className="my-3 relative">
                                <Tooltip
                                    withinPortal={false}
                                    opened={!getDocumentBoard.isLoading && !cover}
                                    label={labelTooltip}
                                    position={desktop ? 'left' : 'bottom'}
                                    placement="center"
                                    radius="md"
                                    withArrow
                                >
                                    <div onClick={() => toggleFileCover()} className="border sizeSVG cursor-pointer border-white rounded-full p-3 transition-opacity hover:opacity-80">
                                        <AiOutlinePlus size={25} color="#fff" />
                                    </div>
                                </Tooltip>
                            </div>
                            :
                            <div onClick={() => scrollToGallery()} className="border sizeSVG cursor-pointer border-white rounded-full p-3 transition-opacity mt-4 hover:opacity-80">
                                <DoubleArrowIcon width={25} height={25} />
                            </div>
                        }
                    </div>
                }
                <a href={getAdmin?.website} target="_blank" rel="noreferrer" className="cursor-pointer absolute flex flex-col justify-center items-center bottom-8 left-1/2 transform -translate-x-1/2">
                        {adminAvatar ? 
                                    <Avatar className="mb-2" radius="xl" size={desktop ? "lg" : 'md'} src={`https://d2uqrxzbny1jco.cloudfront.net/fit-in/200x200/${adminAvatar}`} alt="AvatarAdmin" />
                                    : 
                                    (!adminAvatar && adminFirstName && adminLastName 
                                    ?
                                        <Avatar className="mb-2 uppercase" color="blue" radius="xl" style={{width:'50px',height:'50px'}} src={null} alt="AvatarUser">{adminInitials}</Avatar>
                                    :
                                        <Avatar className="mb-2 uppercase" color="blue" radius="xl" style={{width:'50px',height:'50px'}} src={null} alt="AvatarUser" />
                        )}
                    <h1 className="headingPhotograph">{adminFirstName} {adminLastName}</h1>
                </a>
            </div>
            <Portal position={'fixed'}>
                <div className={`h-0 w-0 invisible qrCode${subdomain}`}>
                    <QRCodeCanvas size={300} value={`https://picboard.ro/${subdomain}`} />
                </div>
            </Portal>
            {!getDocumentBoard.isLoading && 
                <BoardBar 
                    disableFullScreen={disableFullScreen}
                    isSearchLoading={isSearchLoading}
                    setOpenModalPhotos={setOpenModalPhotos}
                    setOpenAdminPanel={setOpenAdminPanel}
                    setDisableFullScreen={setDisableFullScreen}
                    onFaceIdClick={onFaceIdClick}
                    showOnlyMatching={showOnlyMatching}
                    saveQRCode={saveQRCode}
                    setPublishModal={setPublishModal}
                    selected={selected}
                    tabEvent={tabEvent}
                    highlightsPhotos={highlightsPhotos}
                    onHighlightsPhotos={onHighlightsPhotos}
                />
            }
            <Container className={"picboard-gallery"} fluid={true} px={2} style={{minHeight:'70vh',height:'100%',paddingBottom:'50px'}} >

            {!admin && 
            <div className={`bg-white z-20 w-full ${isVisibleCover ? 'h-[0px] opacity-0 duration-150 overflow-hidden' : 'h-[68px] duration-150 overflow-auto opacity-100'} flex md:hidden justify-between items-center px-8 fixed bottom-0`}>
                <div onClick={() => tabEvent('all')} className={`flex gap-x-2 relative py-6 justify-center gap-y-1 items-center ${!showOnlyMatching ? 'opacity-100' : 'opacity-50'}`}>
                    {!showOnlyMatching && <div className="bg-[#3c3c3c] absolute top-0 left-0 w-full h-[6px] rounded-full"></div>}
                    <ImageIcon width={16} height={16} />
                    <h1 className="text-sm font-[500] text-[#3c3c3c]">Fotografii publice</h1>
                </div>
                <div onClick={() => tabEvent('selfie')} className={`flex gap-x-2 relative py-6 justify-center gap-y-1 items-center ${showOnlyMatching ? 'opacity-100' : 'opacity-50'}`}>
                    {showOnlyMatching && <div className="bg-[#3c3c3c] absolute top-0 left-0 w-full h-[6px] rounded-full"></div>}
                    <PhotosIcon width={16} height={16} />
                    <h1 className="text-sm font-[500] text-[#3c3c3c]">Fotografii private</h1>
                </div>
            </div>}

                {(board && admin && !showOnlyMatching && !highlightsPhotos) &&
                    <Gallery
                        userId={user?.uid}
                        isSearch={false}
                        isAdmin={admin}
                        selected={selected}
                        onEvent={(name, data) => {

                            if (name === "ITEM_CLICKED" && disableFullScreen) {
                                if (selected.includes(data.id)) {
                                    setSelected(selected.filter((id) => id !== data.id))
                                } else {
                                    setSelected([
                                        ...selected,
                                        data.id
                                    ])
                                }
                            }
                        }} disableFullscreen={disableFullScreen}  board={board} options={options} container={container} scrollingElement={scrollingElement}
                    />  
                }

                {(board && admin && showOnlyMatching && !highlightsPhotos && board) &&
                    <Gallery
                        userId={user?.uid}
                        isSearch={true}
                        isLoading={isSearchLoading}
                        isAdmin={admin}
                        selected={selected}
                        onEvent={(name, data) => {

                            if (name === "ITEM_CLICKED" && disableFullScreen) {
                                if (selected.includes(data.id)) {
                                    setSelected(selected.filter((id) => id !== data.id))
                                } else {
                                    setSelected([
                                        ...selected,
                                        data.id
                                    ])
                                }
                            }
                        }} disableFullscreen={disableFullScreen}  board={board} options={options} container={container} scrollingElement={scrollingElement}
                    />  
                }

                {(board && admin && !showOnlyMatching && highlightsPhotos && board) &&
                    <Gallery
                       userId={user?.uid}
                       isSearch={false}
                       isAdmin={admin}
                       isHighlightsPhotos={highlightsPhotos}
                       selected={selected}
                       onEvent={(name, data) => {
   
                           if (name === "ITEM_CLICKED" && disableFullScreen) {
                               if (selected.includes(data.id)) {
                                   setSelected(selected.filter((id) => id !== data.id))
                               } else {
                                   setSelected([
                                       ...selected,
                                       data.id
                                   ])
                               }
                           }
                       }} disableFullscreen={disableFullScreen}  board={board} options={options} container={container} scrollingElement={scrollingElement}
                    />  
                }

                {(board && !admin && !isPublished) && <BoardNotification board={getDocumentBoard} userData={userData} />}


                {(board && !admin && isPublished && !hasSelfie && showOnlyMatching) && 
                    <Container fluid={true} className={'mt-10 pb-10'} id="contentGallery">
                        <div className="w-full max-w-[700px] mx-auto">
                            <Title  align="center" style={{marginBottom:'0.5rem',color:'#3c3c3c'}} order={1}>Caută fotografiile tale</Title>
                            <Title align="center" style={{marginBottom:'1.5rem',color:'#3c3c3c'}} order={5}>Pentru a vizualiza fotografiile cu tine din cadrul evenimentului te rugăm să îți faci un selfie.</Title>
                            <div className="w-full max-w-[175px] mx-auto">
                                <img src={SelfieImage} alt="selfie" className="w-full h-full" />
                            </div>
                            <ButtonCustom className="mx-auto mt-4 w-full max-w-[200px]" label="Începe" onClick={() => handleIncepeSelfie()}  />
                        </div>
                    </Container>
                }

                {(board && !admin && isPublished && !hasSelfie && !showOnlyMatching) && 
                    <Gallery
                    isLoading={isSearchLoading}
                    userId={user?.uid}
                    isSearch={false}
                    isAdmin={admin}
                    selected={selected}
                    onEvent={(name, data) => {

                        if (name === "ITEM_CLICKED" && disableFullScreen) {
                            if (selected.includes(data.id)) {
                                setSelected(selected.filter((id) => id !== data.id))
                            } else {
                                setSelected([
                                    ...selected,
                                    data.id
                                ])
                            }
                        }
                    }} disableFullscreen={disableFullScreen}  board={board} options={options} container={container} scrollingElement={scrollingElement}
                /> 
                }

                {(board && !admin && isPublished && hasSelfie && showOnlyMatching) && 
                    <Gallery
                        isLoading={isSearchLoading}
                        userId={user?.uid}
                        isSearch={true}
                        isAdmin={admin}
                        selected={selected}
                        onEvent={(name, data) => {

                            if (name === "ITEM_CLICKED" && disableFullScreen) {
                                if (selected.includes(data.id)) {
                                    setSelected(selected.filter((id) => id !== data.id))
                                } else {
                                    setSelected([
                                        ...selected,
                                        data.id
                                    ])
                                }
                            }
                        }} disableFullscreen={disableFullScreen}  board={board} options={options} container={container} scrollingElement={scrollingElement}
                    /> 
                }

                {(board && !admin && isPublished && hasSelfie && !showOnlyMatching) &&
                    <Gallery
                    userId={user?.uid}
                    isSearch={false}
                    isAdmin={admin}
                    selected={selected}
                    onEvent={(name, data) => {

                        if (name === "ITEM_CLICKED" && disableFullScreen) {
                            if (selected.includes(data.id)) {
                                setSelected(selected.filter((id) => id !== data.id))
                            } else {
                                setSelected([
                                    ...selected,
                                    data.id
                                ])
                            }
                        }
                    }} disableFullscreen={disableFullScreen}  board={board} options={options} container={container} scrollingElement={scrollingElement}
                /> 
                } 

            </Container>
            {board && publishModal && <ModalPublishComponent opened={publishModal} setOpened={setPublishModal} board={board}/>}
            {board && <MembersPanelModal opened={openAdminPanel} setOpened={setOpenAdminPanel} board={board}/>}
            {openModalPhotos && <UploadGallery opened={openModalPhotos} setOpened={(v) => window.location.reload()} board={board} />}
            {openModalQRSelfie &&   <ModalQRSelfie subdomain={subdomain} opened={openModalQRSelfie} setOpened={setOpenModalQRSelfie} />}
        </>
    )

}